<script>
import Mixin from "@utilities/mixin";

export default {
  mixins: [Mixin],
  data() {
    return {
      selectedShop: null,
      visible: false
    }
  },
  computed: {
    shops() {
      return this.$store.state.shops;
    },
    user() {
      return this.$store.state.user;
    }
  },
  methods: {
    register() {
      this.login(this.user.ID, this.selectedShop);
      this.visible = false;
    },
    checkIfRegistered() {
      const loggedInUser = JSON.parse(sessionStorage.getItem('sbUserId'));
      const currentShop = JSON.parse(sessionStorage.getItem('sbShopId'));
      const isRegistered = loggedInUser && currentShop;
      this.$emit('check', isRegistered);
      this.visible = !isRegistered;
    }
  },
  created() {
    this.getShops();
    this.getCurrentUser();
    this.checkIfRegistered();
    window.addEventListener('click', this.checkIfRegistered);
  },
  beforeDestroy() {
    window.removeEventListener('click', this.checkIfRegistered);
  }
}
</script>

<template>
  <div class="flex justify-center">
    <Button severity="primary" label="Select Shop" @click="visible = true" />
    <Dialog v-model:visible="visible" modal header="Select Shop" :style="{ width: '20rem' }">
      <div class="flex gap-4">
        <Select id="shop" class="w-full" placeholder="Select a shop"
                v-model="selectedShop" :options="shops"
                optionLabel="name" optionValue="id"
                autocomplete="off" aria-describedby="Select Shop"/>
        <Button type="button" label="Enter" severity="primary" @click="register"/>
      </div>
    </Dialog>
  </div>
</template>